import { Box } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { HeaderDesktop } from "./Desktop";
import { HeaderMobile } from "./Mobile";

export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);

  const router = useRouter();

  const isHomePage = router.pathname === "/";

  const backgroundColor = isHomePage ? "transparent" : "white";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100); // seuil du scroll (30px ici)
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box alignSelf="flex-start" marginBottom="-18px">
      <HeaderDesktop
        isScrolled={isScrolled}
        isHomePage={isHomePage}
        backgroundColor={backgroundColor}
      />

      <HeaderMobile
        isScrolled={isScrolled}
        isHomePage={isHomePage}
        backgroundColor={backgroundColor}
      />
    </Box>
  );
}
